import { render } from "./PermissionRole.vue?vue&type=template&id=47b3f2d9&ts=true"
import script from "./PermissionRole.vue?vue&type=script&lang=ts"
export * from "./PermissionRole.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__